import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../apollo-client';

import {SenderAddressMigrationBanner} from './sender-address-migration-banner';

export function mountSenderAddressMigrationBanner() {
    const senderAddressMigrationBannerContainer = document.querySelector(
        '#react-mount-sender-address-banner'
    );
    if (senderAddressMigrationBannerContainer) {
        ReactDOM.render(
            <ApolloProvider client={nutApolloClient}>
                <ReactHooksApolloProvider client={nutApolloClient}>
                    <SenderAddressMigrationBanner />
                </ReactHooksApolloProvider>
            </ApolloProvider>,
            senderAddressMigrationBannerContainer
        );
    }
}
